import $http from "../../axios";
import { Notification } from "element-ui";

// obtener Data libro Contable
export async function fetchReportBalanceForContacts({commit, state}) {
    state.loading.module = true;
    await $http.get('/api/reporte-saldos-por-tercero', { params : state.params})
        .then((response) => {
            commit('setReportData', response.data.data);
            state.loading.module = false;
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: 'Error',
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}
export async function fetchContactsByType({commit,state}) {
    await $http.get('/api/terceros-lite', { params : state.params_contact})
        .then((response) => {
            commit('setContacts', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        })
}
export async function fetchAccounts({ commit, state }, text) {
    await $http
        .get("/api/cuentas-lite",{ params : {filter:text}})
        .then(response => {
            commit("setAccounts", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}



// WEBPACK FOOTER //
// ./src/modules/balance-for-contacts/actions.js